import { render, staticRenderFns } from "./ItemRelationsDataTable.vue?vue&type=template&id=22d449f6&"
import script from "./ItemRelationsDataTable.vue?vue&type=script&lang=js&"
export * from "./ItemRelationsDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports